export class LanguageMapper {
  private static readonly LANG_MAP: { [key: string]: string } = {
    'en': 'en',
    'en-US': 'en',
    'ru': 'ru',
    'ru-RU': 'ru',
    'uz': 'uz',
    'uz-Latn-UZ': 'uz'
  };

  static normalize(langCode: string): string {
    return this.LANG_MAP[langCode] || 'en';
  }
}

